import { render, staticRenderFns } from "./AmbientTransition.vue?vue&type=template&id=ffee5936&scoped=true"
import script from "./AmbientTransition.vue?vue&type=script&lang=js"
export * from "./AmbientTransition.vue?vue&type=script&lang=js"
import style0 from "./AmbientTransition.vue?vue&type=style&index=0&id=ffee5936&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffee5936",
  null
  
)

export default component.exports